import { Component, OnInit, Input, TemplateRef, Inject } from '@angular/core';
import { ProcessoMovimentacao, TipoMovimentacao } from '@app/models/processo-movimentacao';
import { EncaminharPrazo } from '@app/pages/processos/gerenciar-prazos/gerenciar-prazos.model';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilitarioService } from '@app/services/utilitario.service';
import { PrazoService } from '@app/services/prazo.service';
import { ProcessoService } from '@app/services/processo.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { MeAvise } from '@app/models/me-avise';
import { ToastrService } from 'ngx-toastr';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { debounce, debounceTime, throttleTime } from 'rxjs/operators';


@Component({
  selector: 'app-movimentacao-historico',
  templateUrl: './movimentacao-historico.component.html',
  styleUrls: ['./movimentacao-historico.component.scss']
})
export class MovimentacaoHistoricoComponent implements OnInit {

  private _tipoMovimentacao: TipoMovimentacao = null;
  get tipoMovimentacao(): TipoMovimentacao {
    return this._tipoMovimentacao;
  }
  private _processoId: number = null;
  get processoId(): number {
    return this._processoId;
  }

  @Input()
  set tipoMovimentacao(tipoMovimentacao: TipoMovimentacao) {
    const tmp = this._tipoMovimentacao;
    this._tipoMovimentacao = tipoMovimentacao;
    if (tmp) {
      this.obterMovimentacao();
    }
  }
  @Input()
  set processoId(processoId: number) {
    if (this.encaminharId) {
      this.encaminhado = false;
    }

    const tmp = this._processoId;
    this._processoId = processoId;
    if (tmp) {
      this.obterMovimentacao();
    }
  }
  @Input() encaminharId: number;
  @Input() telaEncaminhar: boolean;

  lstProcessoMovimentacao: ProcessoMovimentacao[] = [];
  loading = false;

  lstErros: string[] = [];
  recarregarmodal= true
  listaFuncionarios: IdDescricao[];
  encaminhado = false;
  encaminharPrazo: EncaminharPrazo = new EncaminharPrazo();
  meaviseTransferencia: MeAvise;
  usuarioIdTransferencia: number;
  dataTransferencia: string;
  solicitarArquivo: boolean = false;
  aguardeEncaminhar: boolean = false;

  modalRef: BsModalRef;

  constructor(
    private processoService: ProcessoService,
    private consultasService: ConsultasService,
    private prazoService: PrazoService,
    @Inject(ToastrService) public toastr: ToastrService,
    public modalService: BsModalService,
    private utilitarioService: UtilitarioService
  ) {
    this.lstProcessoMovimentacao = [];
    this.listaFuncionarios = [];
  }

  bsModalRef: BsModalRef;

  ngOnInit() {
    this.obterMovimentacao();
  }

  public obterMovimentacao() {
    this.loading = true;
    this.processoService.obterMovimentacaoGeral(this._tipoMovimentacao, this._processoId)
      .subscribe(
        data => {
          this.lstProcessoMovimentacao = data;
          this.loading = false;
        },
        () => { 
          this.toastr.warning("Não foi possível buscar as movimentações, tente novamente!")
          this.lstProcessoMovimentacao = [];
          this.loading = false
        });
    this.consultasService.consultar('USUARIO').toPromise().then(data => this.listaFuncionarios = data);
  }

  public obterArquivo(id: number) {
    this.solicitarArquivo = true;
    this.processoService.obterSasUrlParaDownloadMovimentacaoAnexo(id).subscribe((uriString) => {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.href = uriString;
      a.protocol = "https";
      a.click();
      a.remove();
    },() => {
      this.solicitarArquivo = false;
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  fecharModal() {
    this.recarregarmodal = false;
    this.modalRef.hide();
    this.modalRef = null;
  }
  encaminhar(movimentacaoId: number, template: TemplateRef<any>) {
    this.openModal(template);

    this.encaminharPrazo.MeAviseId = this.encaminharId;
    this.encaminharPrazo.MovimentacaoId = movimentacaoId;
    this.encaminharPrazo.Descricao = 'PROTOCOLAR ' + UtilitarioService.retornaDataAtualMaisDias(0);
    this.encaminharPrazo.UsuarioId = null;
  }

  realizar(prazoId: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente marcar como realizado?';
    this.bsModalRef.content.confirmar = () => {
      this.processoService.realizarMeAvisePrazo(prazoId).toPromise().then(
        () => this.obterMovimentacao(),
        data => this.toastr.error(data.errors[0]));
    };
  }

  transferir(meavise: MeAvise, template: TemplateRef<any>) {
    this.openModal(template);
    this.meaviseTransferencia = meavise;
  }

  transferirConfirmar() {
    this.meaviseTransferencia.Data = this.dataTransferencia ?? this.meaviseTransferencia.Data;

    if (this.usuarioIdTransferencia != null) {
      this.prazoService.transferirMeAvise(
        this.usuarioIdTransferencia,
        this.meaviseTransferencia
      ).toPromise().then(() => {
        this.toastr.success('Transferido com sucesso!', null);
        this.fecharModal();
        this.obterMovimentacao();
      }, () => {
        this.toastr.error('Não transferido!', 'Tente Novamente!');
      });
    } else {
      this.toastr.error('Selecione um funcionário', 'Aviso!');
    }
  }

  encaminharConfirmar() {
    if(!this.encaminharPrazo.UsuarioId){
      this.toastr.error('Selecione um funcionário', 'Aviso!');
      return;
    }

    this.aguardeEncaminhar = true;
    
      this.encaminharPrazo.EncaminhadoId = this.encaminharId;
      this.prazoService.encaminharPrazo(this.encaminharPrazo)
        .toPromise().then(() => {
          this.encaminhado = true;
          this.toastr.success('Encaminhado com sucesso!', null);
          this.fecharModal();
          this.obterMovimentacao();
        },
        (BadRequest) => {
          if (BadRequest.error) {
            this.recarregarmodal = true;
            this.lstErros[0] = BadRequest.error[0]["Valor"];
          }
        })
        .finally(() => this.aguardeEncaminhar = false);
  }
}
